export enum WholeStoryDiscountTypeEnum {
  COIN_PRICE = 'COIN_PRICE',
  PERCENTAGE = 'PERCENTAGE',
}

export const wholeStoryDiscountTypeLabel: Record<
  WholeStoryDiscountTypeEnum,
  string
> = {
  [WholeStoryDiscountTypeEnum.COIN_PRICE]: 'ลดแบบเหรียญ',
  [WholeStoryDiscountTypeEnum.PERCENTAGE]: 'ลดแบบ %',
}
